import { createAsyncThunk } from '@reduxjs/toolkit';

import BorrowerApi from 'api/BorrowerApi';

export const getBorrowerShortInfoThunk = (borrowerApi: BorrowerApi) =>
  createAsyncThunk('borrower/getBorrowerShortInfo', async (data: { ssn?: string; email?: string }) => {
    return await borrowerApi.getBorrowerShortInfo(data);
  });
